import React from "react";
import CardClass from "../../../CardClass";
import EmptyState from "../../../EmptyState";
import MUIButton from "@mui/material/Button";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUISwitch from "@mui/material/Switch";
import MUIIconButton from "@mui/material/IconButton";
import MUIAddIcon from "@mui/icons-material/Add";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUIGrid from "@mui/material/Grid";
import DialogSearchIssueStatus from "../../../Dialog/Search/DialogSearchIssueStatus";
import TileIssueStatus from "../../../Tile/TileIssueStatus";
import PropTypes from "prop-types";
import MainContext from "../../../../Context/MainContext/MainContext";

export default class CardAdminQueueFilterPatientIssueIssueStatus extends CardClass {
    static contextType = MainContext; // For legacy class components

    constructor(props) {
        super(props);

        this.state.issueStatusDialogOpen = false;
    }

    /**
     * Render the content of the card.
     */
    renderContent() {
        const handleRemove = (issueStatusId) => {
            const filter = this.props.queue.filter;
            if (!filter["patient_issue.issue_status"]?.properties?.value) {
                return;
            }
            filter["patient_issue.issue_status"].properties.value = filter["patient_issue.issue_status"].properties.value.filter((entry) => entry !== issueStatusId);
            if (filter["patient_issue.issue_status"].properties.value.length === 0) {
                delete filter["patient_issue.issue_status"];
            }

            this.props.onChange({
                "filter": filter
            });
        };

        const values = this.props.queue?.filter?.["patient_issue.issue_status"]?.properties?.value || [];

        const excludeChecked = this.props.queue?.filter?.["patient_issue.issue_status"]?.properties?.operator === "not in";

        const handleExcludeToggle = (event) => {
            const filter = this.props.queue.filter;
            filter["patient_issue.issue_status"].properties.operator = event.target.checked ? "not in" : "in";

            this.props.onChange({
                "filter": filter
            });
                };

        if (values.length > 0) {
            return (
                <>
                    <MUIFormControlLabel
                        sx={{ marginLeft: 0 }}
                        control={<MUISwitch color="error" checked={excludeChecked} onChange={handleExcludeToggle} />}
                        label="Exclude"
                    />
                    <MUIGrid container spacing={2}>
                        {values.map((issueStatusId) => {
                            return (
                                <MUIGrid key={issueStatusId} item xs={12} sm={6} md={4}>
                                    <TileIssueStatus
                                        issueStatus={this.context.issueStatusesIndexed[issueStatusId]}
                                        iconButtons={[(<MUIIconButton onClick={() => handleRemove(issueStatusId)}><MUIDeleteIcon /></MUIIconButton>)]}
                                    />
                                </MUIGrid>
                            );
                        })}
                        {this.renderDialog()}
                    </MUIGrid>
                </>
            );
        } else {
            return (
                <>
                    <EmptyState
                        line1="Not Configured"
                        line2="Showing all Issue Statuses"
                    />
                    {this.renderDialog()}
                </>
            );
        }
    }



    /**
     * Renders a search dialog of Issue Statuses
     */
    renderDialog() {
        const handleAdd = (issueStatus) => {
            const filter = (this.props.queue && this.props.queue.filter) || {};
            if (!filter["patient_issue.issue_status"]) {
                filter["patient_issue.issue_status"] = {
                    type: "set",
                    properties: {
                        operator: "in",
                        value: [],
                    },
                };
            }
            filter["patient_issue.issue_status"].properties.value = [...new Set([...(filter["patient_issue.issue_status"].properties.value || []), issueStatus.id])];

            this.props.onChange({
                "filter": filter
            });
        };

        return (
            <DialogSearchIssueStatus
                open={this.state.issueStatusDialogOpen}
                onClose={() => this.setState({ issueStatusDialogOpen: false })}
                onSelect={handleAdd}
            />
        );
    }

    /**
     * Renders add Issue Status button
     */
    getActions() {
        const handleAdd = () => {
            this.setState({
                issueStatusDialogOpen: true,
            });
        };

        const buttonItems = [(<MUIButton
                component="label"
                variant="outlined"
                startIcon={<MUIAddIcon />}
                onClick={handleAdd}>Add Issue Status</MUIButton>)
        ];

        return buttonItems;
    }

    /**
     * @returns {string} The title of the card.
     */
    getTitle() {
        return "Filter: Patient Issue > Issue Status";
    }
}